<template>
  <div>
    <v-tooltip
      v-model="tooltipIsVisible"
      top
      transition="fade-transition"
      color="black"
    >
      <template v-slot:activator="{ on }">
        <div v-on="on"></div>
      </template>
      <span>Copied to Clipboard</span>
    </v-tooltip>
    <button text class="och-textCopier" @click="textToClipboard(value)">
      {{ value }}
    </button>
  </div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      timeoutId: null,
      tooltipIsVisible: false,
    };
  },
  methods: {
    textToClipboard(text) {
      // Taken from https://stackoverflow.com/questions/33855641/copy-output-of-a-javascript-variable-to-the-clipboard
      const dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.showTooltip();
    },
    showTooltip() {
      this.tooltipIsVisible = true;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.tooltipIsVisible = false;
      }, 2000);
    },
  },
  props: ["value"],
};
</script>

<style>
.och-textCopier {
  cursor: pointer;
  height: 100%;
  text-align: left;
  width: 100%;
}
</style>
